import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { CyclistService } from 'src/app/services/cyclist.service';
import { BikeService } from 'src/app/services/bike.service';
import { HelpersService } from 'src/app/services/helpers.service';
import { GearManagementService } from 'src/app/services/gear-management.service';

@Component({
  selector: 'app-workshop-jobcard-add-customer-item',
  templateUrl: './workshop-jobcard-add-customer-item.component.html',
  styleUrls: ['./workshop-jobcard-add-customer-item.component.scss']
})
export class WorkshopJobcardAddCustomerItemComponent {

  @Input() jobcard: any;
  @Input() partnerType: string = 'other';
  @Input() partnerTypeID: number = 99;
  @Input() itemTypes: any[] = [];
  @Output() itemSelected = new EventEmitter<any>();

  public item: any = {};
  public updating: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private userService: UserService,
    private cyclistService: CyclistService,
    private helpersService: HelpersService,
    private bikeService: BikeService,
    private gearService: GearManagementService,
  ) { }

  ngOnInit() {
    if (this.partnerType === 'bicycle') {
      this.item.typeID = 99; // Default type for bicycle
      if(this.itemTypes?.length === 0){
        this.getBikeTypes();
      }
    }
  }

  getBikeTypes() {
    this.gearService.getBikeTypes().subscribe((types) => {
      this.itemTypes = types.map((x) => {
        return { value: x.id, label: this.translate.instant(x.label) };
      });
    });
  }

  isValidItem(): boolean {
    return this.item.manufacturer && this.item.model;
  }

  createItem() {
    if (this.isValidItem()) {
      this.updating = true;
      let item = {
        ID: 0,
        UserID: this.jobcard.customer.ID,
        RefNo:
          this.item.manufacturer +
          (this.item.model && this.item.model.length > 0
            ? ' - ' + this.item.model
            : ''),
        SerialNo: this.item.serialNo,
        Manufacturer: this.item.manufacturer,
        Model: this.item.model || '',
        Colour: this.item.colour || '',
        ModelYear: this.item.modelYear || 0,
        BikeSize: this.item.bikeSize || '',
        TypeID: this.item.typeID || 99,
        StatusID: 0,
        PartnerType: this.partnerTypeID,
        LastService: new Date()
      };
      this.bikeService.saveBike(item).subscribe(
        (newItem) => {
          this.updating = false;

          var selectedItem = {
            id: newItem.ID,
            manufacturer: newItem.Manufacturer,
            model: newItem.Model,
            serialNo: newItem.SerialNo,
            typeID: newItem.TypeID,
            colour: newItem.Colour,
            modelYear: newItem.ModelYear,
            bikeSize: newItem.BikeSize,
          }

          this.activeModal.close({ selectedItem: selectedItem });
        },
        (error) => {
          this.updating = false;
        },
      );

    } else {

    }
  }

  @HostListener('document:keydown.enter', ['$event'])
  handleEnter(event: KeyboardEvent) {
    this.createItem();
  }
}

